/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cloud_logic_custom": [
    {
      "name": "IBMaraudersMapRest",
      "endpoint": "https://8xfb672y3m.execute-api.us-east-1.amazonaws.com/dev",
      "region": "us-east-1"
    }
  ],
  "aws_dynamodb_all_tables_region": "us-east-1",
  "aws_dynamodb_table_schemas": [
    {
      "tableName": "gsf_shipment_items_2_beta",
      "region": "us-east-1"
    },
    {
      "tableName": "iris_fc_info",
      "region": "us-east-1"
    }
  ],
  "aws_user_files_s3_bucket": "gsf-iris-dataloader",
  "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
